import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/default/header";
import MockupReport from "./mockupChart";
import MockupList from "./mockupList";
import SingleSidebarMenu from "../../business/menu/singleSidebarMenu";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";

const CardMockup = () => {
    return (
        <div className="business-wrapper sidebar-menu-enable">
        <Helmet title="Business" />
        <Header />
        <div className="sidebar-with-content ds-flex">
             <SingleSidebarMenu />
            <div className="content-right">
                <Breadcrumb />
                <MockupReport />
                <MockupList />
            </div>
        </div>
    </div>
    );
}

export default CardMockup;